import * as React from 'react'
import { Badge, Tooltip } from '@atoms'

type OverflowListProps<T = unknown> = {
    name: string
    items: T[]
    renderItem: (item: T) => React.ReactNode
    separator?: 'string'
    terminator?: 'string'
}

export const OverflowList: React.FC<OverflowListProps> = (props) => {
    const {
        name,
        items,
        renderItem = defaultRenderItem,
        separator = '; ',
        terminator = '.',
    } = props

    const hiddenItems = items.slice(1)

    const joinedHiddenItems = hiddenItems.map((item, index) => (
        <React.Fragment key={index}>
            {renderItem(item)}
            {index < hiddenItems.length - 1 ? separator : terminator}
        </React.Fragment>
    ))

    if (!items[0]) {
        return null
    }

    return (
        <div className="flex items-center gap-2">
            {renderItem(items[0])}
            {items.length > 1 && (
                <Tooltip name={name} content={joinedHiddenItems}>
                    <Badge>{`+${String(items.length - 1)}`}</Badge>
                </Tooltip>
            )}
        </div>
    )
}

const defaultRenderItem: OverflowListProps['renderItem'] = (item) => {
    if (typeof item === 'string') {
        return item
    }

    return null
}
